/*
 * EU Right of Withdrawal — two-step withdrawal form enhancement.
 * Baseline works without JS (native Shopify contact form). With JS:
 *   Step 1 (data) -> validate -> Step 2 (review + explicit confirm) -> submit.
 * If a backend endpoint is configured, submit is sent as JSON via fetch
 * (so the backend can send the automatic confirmation email to the customer).
 * Otherwise the native contact form posts to the merchant as a fallback.
 */
(function () {
  'use strict';

  function initWithdrawal(root) {
    var form = root.querySelector('form');
    if (!form) return;

    var endpoint = (root.getAttribute('data-endpoint') || '').trim();
    var step1 = root.querySelector('[data-wd-step="1"]');
    var step2 = root.querySelector('[data-wd-step="2"]');
    var nextBtn = root.querySelector('[data-wd-next]');
    var backBtn = root.querySelector('[data-wd-back]');
    var submitBtn = root.querySelector('[data-wd-submit]');
    var confirmBoxes = root.querySelectorAll('[data-wd-confirm]');
    var review = root.querySelector('[data-wd-review]');
    var errBox = root.querySelector('[data-wd-error]');
    var errText = root.querySelector('[data-wd-error-text]');
    var okBox = root.querySelector('[data-wd-success]');
    if (!step1 || !step2 || !nextBtn) return;

    var msg = {
      required: root.getAttribute('data-msg-required') || 'Please fill in all required fields.',
      email: root.getAttribute('data-msg-email') || 'Please enter a valid email address.',
      phone: root.getAttribute('data-msg-phone') || 'Please enter a valid phone number.',
      confirm: root.getAttribute('data-msg-confirm') || 'Please confirm to continue.',
      generic: root.getAttribute('data-msg-generic') || 'Something went wrong. Please try again.',
      iban: root.getAttribute('data-msg-iban') || 'Please enter a valid IBAN.',
      ibanCountry: root.getAttribute('data-msg-iban-country') || 'We currently accept IBANs only from:',
      sending: root.getAttribute('data-msg-sending') || 'Sending…'
    };

    // Allowed IBAN country prefixes (theme switch). Empty list = any country.
    var ibanCountries = (root.getAttribute('data-iban-countries') || '')
      .toUpperCase().split(/[,\s]+/).filter(Boolean);

    // JS is on: collapse to a real two-step flow.
    step2.hidden = true;
    step1.hidden = false;

    function fields() {
      return Array.prototype.slice.call(root.querySelectorAll('[data-wd-field]'));
    }
    function showError(text) {
      if (!errBox) return;
      if (errText) errText.textContent = text;
      errBox.hidden = false;
    }
    function clearError() { if (errBox) errBox.hidden = true; }
    // All consent checkboxes must be ticked before the request can be sent.
    function allConfirmed() {
      for (var i = 0; i < confirmBoxes.length; i++) { if (!confirmBoxes[i].checked) return false; }
      return true;
    }
    function validEmail(v) { return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v); }
    // Lenient, international-friendly phone check: plausible characters + 6–15 digits.
    function validPhone(v) {
      v = (v || '').trim();
      var digits = v.replace(/\D/g, '');
      return /^[+0-9][0-9 ()\/.\-]{4,}$/.test(v) && digits.length >= 6 && digits.length <= 15;
    }
    function normIban(v) { return (v || '').replace(/\s+/g, '').toUpperCase(); }
    // Generic ISO 13616 IBAN check (mod-97). Works for every country, catches typos.
    function validIban(v) {
      v = normIban(v);
      if (!/^[A-Z]{2}\d{2}[A-Z0-9]{11,30}$/.test(v)) return false;
      var r = v.slice(4) + v.slice(0, 4), s = '', i, c;
      for (i = 0; i < r.length; i++) {
        c = r.charCodeAt(i);
        s += (c >= 65 && c <= 90) ? (c - 55).toString() : r.charAt(i);
      }
      var rem = 0;
      for (i = 0; i < s.length; i++) { rem = (rem * 10 + (s.charCodeAt(i) - 48)) % 97; }
      return rem === 1;
    }
    function ibanCountryOk(v) {
      if (!ibanCountries.length) return true;
      return ibanCountries.indexOf(normIban(v).slice(0, 2)) !== -1;
    }
    function labelFor(el) {
      var l = el.id ? root.querySelector('label[for="' + el.id + '"]') : null;
      return l ? l.textContent.replace('*', '').trim() : (el.getAttribute('data-wd-field') || '');
    }

    nextBtn.addEventListener('click', function () {
      clearError();
      var missing = false, badEmail = false, badPhone = false, badIban = false, badIbanCountry = false;
      fields().forEach(function (el) {
        var val = (el.value || '').trim();
        var name = el.getAttribute('data-wd-field');
        if (el.hasAttribute('data-wd-required') && !val) missing = true;
        if (name === 'email' && val && !validEmail(val)) badEmail = true;
        if (name === 'phone' && val && !validPhone(val)) badPhone = true;
        if (name === 'iban' && val) {
          if (!validIban(val)) badIban = true;
          else if (!ibanCountryOk(val)) badIbanCountry = true;
        }
      });
      if (missing) { showError(msg.required); return; }
      if (badEmail) { showError(msg.email); return; }
      if (badPhone) { showError(msg.phone); return; }
      if (badIban) { showError(msg.iban); return; }
      if (badIbanCountry) { showError(msg.ibanCountry + ' ' + ibanCountries.join(', ')); return; }

      review.innerHTML = '';
      fields().forEach(function (el) {
        var val = (el.value || '').trim();
        if (!val) return;
        var row = document.createElement('div');
        row.className = 'withdrawal__review-row';
        var lbl = document.createElement('strong');
        lbl.textContent = labelFor(el) + ': ';
        var span = document.createElement('span');
        span.textContent = val;
        row.appendChild(lbl);
        row.appendChild(span);
        review.appendChild(row);
      });

      step1.hidden = true;
      step2.hidden = false;
      step2.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    if (backBtn) {
      backBtn.addEventListener('click', function () {
        clearError();
        step2.hidden = true;
        step1.hidden = false;
      });
    }

    function submitForm() {
      // Honeypot: silently drop bot submissions.
      var hp = form.querySelector('[name="contact[website]"]');
      if (hp && hp.value) return;

      if (confirmBoxes.length && !allConfirmed()) { showError(msg.confirm); return; }

      // No endpoint configured -> native Shopify contact form (kill switch only).
      if (!endpoint) { form.submit(); return; }

      clearError();
      var origVal = submitBtn ? submitBtn.value : '';
      if (submitBtn) { submitBtn.disabled = true; submitBtn.value = msg.sending; }

      var payload = {
        locale: root.getAttribute('data-locale') || '',
        shop_domain: root.getAttribute('data-shop') || '',
        ts: new Date().toISOString()
      };
      fields().forEach(function (el) {
        var name = el.getAttribute('data-wd-field');
        var val = (el.value || '').trim();
        payload[name] = (name === 'iban') ? normIban(val) : val;
      });
      var tsEl = form.querySelector('[name="cf-turnstile-response"]');
      if (tsEl) payload.turnstile_token = tsEl.value;

      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (r) {
          // Any non-OK (4xx validation/rate-limit, 5xx/503 down) -> honest error.
          if (!r.ok) throw new Error('app');
          return r.json().catch(function () { return { ok: true }; });
        })
        .then(function (data) {
          // Frappe wraps whitelisted return values under "message".
          var res = (data && data.message) ? data.message : data;
          if (res && res.ok === false) throw new Error('app');
          form.hidden = true;
          if (okBox) { okBox.hidden = false; okBox.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
        })
        .catch(function () {
          if (submitBtn) { submitBtn.disabled = false; submitBtn.value = origVal; }
          showError(msg.generic);
        });
    }

    // The submit control is type="button" (see snippet) so the native Shopify contact
    // form — and its reCAPTCHA + fake "message sent" screen — can NEVER be triggered when
    // an endpoint is set. We wire the button click directly, and also guard the form's
    // submit event (Enter key) with preventDefault. Native posting happens ONLY via the
    // explicit form.submit() in submitForm() when no endpoint is configured (kill switch).
    if (submitBtn) submitBtn.addEventListener('click', submitForm);
    form.addEventListener('submit', function (e) {
      if (endpoint) { e.preventDefault(); submitForm(); }
    });
  }

  function boot() {
    var nodes = document.querySelectorAll('[data-withdrawal]');
    Array.prototype.forEach.call(nodes, initWithdrawal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
